module.exports = __webpack_public_path__ + "media/images/arrows/twisted/green-down-4e13a751358f626a78437f185908fec3.svg";